import React, { useMemo } from 'react'

function buildSearchUrl(query) {
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`
}

function buildYoutubeUrl(query) {
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`
}

export default function StudyResources({ grade, topic }) {
  const resources = useMemo(() => {
    const topicLabel = topic || 'matemática'
    const gradeLabel = grade ? `${grade}º ano` : 'ensino fundamental'
    return {
      portals: [
        { label: 'Khan Academy', url: `https://pt.khanacademy.org/search?page_search_query=${encodeURIComponent(`${gradeLabel} ${topicLabel}`)}` },
        { label: 'Matemática de Singapura', url: buildSearchUrl(`matemática de singapura ${gradeLabel} ${topicLabel}`) },
        { label: 'Matemática com solução alternativa', url: buildSearchUrl(`métodos alternativos matemática ${gradeLabel} ${topicLabel}`) }
      ],
      videos: [
        { label: 'Vídeo da aula', url: buildYoutubeUrl(`${gradeLabel} ${topicLabel}`) },
        { label: 'Vídeo de blocos', url: buildYoutubeUrl(`${topicLabel} programação em blocos crianças`) },
        { label: 'Vídeo de game', url: buildYoutubeUrl(`${topicLabel} game educativo ${gradeLabel}`) }
      ]
    }
  }, [grade, topic])

  return (
    <div className="grid cols-2">
      <div className="surface-card compact">
        <h3>Portais e métodos</h3>
        <ul className="list-soft">
          {resources.portals.map((item) => (
            <li key={item.url}><a href={item.url} target="_blank" rel="noreferrer">{item.label}</a></li>
          ))}
        </ul>
      </div>
      <div className="surface-card compact">
        <h3>Vídeos relacionados</h3>
        <ul className="list-soft">
          {resources.videos.map((item) => (
            <li key={item.url}><a href={item.url} target="_blank" rel="noreferrer">{item.label}</a></li>
          ))}
        </ul>
      </div>
    </div>
  )
}
